import { GrupaRoba } from "../types/GrupaRoba";

const API_URL = "https://rodendaonica.com/get_data.php";

export const fetchGrupaRoba = async (): Promise<GrupaRoba[]> => {
    try {
        const response = await fetch(API_URL,
            {
                method: "POST",
                headers:{
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(
                    {
                        Funkcija:"GrupaRoba"
                    }),

            });
        if (!response.ok) {
            throw new Error("Greška pri dohvaćanju podataka");
        }
        return await response.json();
    } catch (error) {
        console.error("API greška:", error);
        return [];
    }
};
